import React from "react";
import Table from "../../../../../../../common/components/molecule/Table/Table";
import { TransactionStatus, TransactionType } from "../../../../../types/transaction.types";
import StatusBox from "../../../../../../../common/components/atom/StatusBox/StatusBox";
import { numberFormaterString } from "../../../../../../../utils/numberFormater";
import { JWayIcon } from "../../../../../../../common/assets/JWayIcons";
import { limitString } from "../../../../../../../utils/string.utils";

export interface ListTransactionProps {
  content?: TransactionItem[];
  nbFound?: number;
}

export interface TransactionItem {
  id: string;
  date: string;
  typeTransaction: TransactionType;
  description?: string;
  amount: number;
  unit?: string;
  onClick?: () => void;
  status?: TransactionStatus
}
export default function ListTransactionView({ nbFound, content}: ListTransactionProps) {
  return (
    <Table
      NbFoundViewProps={{
        nbFound,
        itemName: {
          single: "transaction trouvée",
          plurial: "transactions trouvées",
        },
      }}
      headerTitle={["Date", "Description"]}
      bodyData={content?.map((item) => ({
        id: item.id,
        onRowClick: item.onClick,
        data: [
          () =><><p style={{fontSize: "0.9rem", padding: 0, margin: 0, marginRight: 0}}>{item.date}{" "} 
          { (item.status &&item.status === "SUCCESS") ?"" :
          <JWayIcon 
          type={item.status === "PENDING" ? "time" : item.status === "FAILED" ? "cross" : "time"}
          size={11}
          color="rgb(162, 162, 162)"
          />}</p>
     
          </> ,
          () => <span title={item.description}>{limitString(item.description || "",50)}</span>,
          () => <AmountView amount={item.amount} type={item.typeTransaction} unit={item.unit} />,
        ],
      })) || []}
      emptyMessage="Aucune transaction trouvée"
    />
  );
}

const AmountView = ({amount, type, unit}: {amount: number, type: TransactionType, unit?: string}) => {

    return(
        <div style={{display: "flex", justifyContent: "flex-end"}}><StatusBox colorType={type === "DEPOSIT" ?  "success": undefined } size={{width: "130px", height: "25px", font:"1rem"}}><p style={{display: "flex"}}>{type === "DEPOSIT" ? "+": "-"} {numberFormaterString(amount)} <span style={{fontSize: "0.6rem", height: "100%", marginLeft: 5, marginTop: -2}}>{unit}</span></p></StatusBox></div>
    )
}


